var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeech(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7692 0.5H9.84616C7.23479 0.5 4.73038 1.53736 2.88387 3.38387C1.03736 5.23038 0 7.73479 0 10.3462C0 18.3462 8.61539 22.0385 14.7692 24.5V20.1923C17.3806 20.1923 19.885 19.1549 21.7315 17.3084C23.578 15.4619 24.6154 12.9575 24.6154 10.3462C24.6154 7.73479 23.578 5.23038 21.7315 3.38387C19.885 1.53736 17.3806 0.5 14.7692 0.5ZM8.98463 11.2077C9.39247 11.2077 9.72309 10.8771 9.72309 10.4692C9.72309 10.0614 9.39247 9.73078 8.98463 9.73078C8.57679 9.73078 8.24617 10.0614 8.24617 10.4692C8.24617 10.8771 8.57679 11.2077 8.98463 11.2077ZM13.0462 10.4692C13.0462 10.8771 12.7156 11.2077 12.3077 11.2077C11.8999 11.2077 11.5693 10.8771 11.5693 10.4692C11.5693 10.0614 11.8999 9.73078 12.3077 9.73078C12.7156 9.73078 13.0462 10.0614 13.0462 10.4692ZM15.6308 11.2077C16.0386 11.2077 16.3693 10.8771 16.3693 10.4692C16.3693 10.0614 16.0386 9.73078 15.6308 9.73078C15.223 9.73078 14.8923 10.0614 14.8923 10.4692C14.8923 10.8771 15.223 11.2077 15.6308 11.2077Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeech);
export default __webpack_public_path__ + "static/media/speech.803111f9.svg";
export { ForwardRef as ReactComponent };